import React, { createContext, useState } from "react";
import {
  DefaultUserContextType,
  IUserContext,
  UserContextType
} from "./UserContextTypes";

export const UserContext = createContext<UserContextType>(
  DefaultUserContextType
);

export const DEFAULT_USER: IUserContext = {
  user_id: -1,
  user_name: "",
  password: "",
  token: "",
  language: "es",
  role: "READER"
};

const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [currentUser, setCurrentUser] = useState<IUserContext>({
    ...DEFAULT_USER
  });

  const saveCurrentUser = (user: IUserContext) => {
    setCurrentUser({ ...user });
  };

  return (
    <UserContext.Provider value={{ currentUser, saveCurrentUser }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
